export const SuggestionsQuestions31 =[

    {
        id: 'SB1-01',
        category: '一般閱讀題',
        type: '選擇題',
        question: '司馬談臨終時最希望司馬遷完成甚麼？',
        options: [
            {
                option: 'A. 接續整理舊聞並完成歷史著作'
            },
            {
                option: 'B. 替李陵向漢武帝求情'
            },
            {
                option: 'C. 專門記錄當代帝王的功績'
            },
            {
                option: 'D. 再次遠遊齊魯而不任官'
            }
        ],
        correctAnswer: 'A. 接續整理舊聞並完成歷史著作',
        explanation: '父親要求「無忘吾所欲論著」，司馬遷承諾整理先人舊聞。',
        score: 1,
        source: '篇章一・父親的囑託',
        articleIndex: [0]
    },
    {
        id: 'SB1-02',
        category: '一般閱讀題',
        type: '選擇題',
        question: '依篇章一，司馬遷受刑後仍選擇活下來的主要原因是甚麼？',
        options: [
            {
                option: 'A. 等待重掌兵權以證明自己'
            },
            {
                option: 'B. 完成尚未完成的著作，使其流傳後世'
            },
            {
                option: 'C. 希望忘記父親的囑託'
            },
            {
                option: 'D. 相信所有人都已理解自己'
            }
        ],
        correctAnswer: 'B. 完成尚未完成的著作，使其流傳後世',
        explanation: '篇章明言他牽掛未成的《史記》，不把原因簡化為畏死。',
        score: 1,
        source: '篇章一・未完成的心願',
        articleIndex: [0]
    },
    {
        id: 'SB1-03',
        category: '一般閱讀題',
        type: '選擇題',
        question: '篇章二認為藺相如的「難」主要在哪裏？',
        options: [
            {
                option: 'A. 只要願意死便能解決一切'
            },
            {
                option: 'B. 不用行動便能保全國家尊嚴'
            },
            {
                option: 'C. 在死亡威脅下仍能冷靜判斷並行動'
            },
            {
                option: 'D. 依靠秦王主動履行承諾'
            }
        ],
        correctAnswer: 'C. 在死亡威脅下仍能冷靜判斷並行動',
        explanation: '「處死者難」指在危局中應對，而非單指接受死亡。',
        score: 1,
        source: '篇章二・藺相如',
        articleIndex: [1]
    },
    {
        id: 'SB1-04',
        category: '一般閱讀題',
        type: '選擇題',
        question: '下列哪項最能概括廉頗晚年的處境？',
        options: [
            {
                option: 'A. 早已放棄趙國，拒絕接受召回'
            },
            {
                option: 'B. 因戰敗而主動請求退休'
            },
            {
                option: 'C. 只求個人享受，無意再上陣'
            },
            {
                option: 'D. 有心效國，卻因讒害及不被信任而失去機會'
            }
        ],
        correctAnswer: 'D. 有心效國，卻因讒害及不被信任而失去機會',
        explanation: '展示食量和披甲上馬反映他希望受用，結局卻是「遂不召」。',
        score: 1,
        source: '篇章二・廉頗',
        articleIndex: [1]
    },
    {
        id: 'SB1-05',
        category: '一般閱讀題',
        type: '選擇題',
        question: '兩篇合讀最能回答哪個核心問題？',
        options: [
            {
                option: 'A. 甚麼信念支持司馬遷在困境中完成《史記》'
            },
            {
                option: 'B. 秦漢軍隊的所有戰術如何發展'
            },
            {
                option: 'C. 哪位人物的食量在古代最大'
            },
            {
                option: 'D. 《史記》每一篇的成書日期是甚麼'
            }
        ],
        correctAnswer: 'A. 甚麼信念支持司馬遷在困境中完成《史記》',
        explanation: '兩篇從著書志向與人物的困境選擇探討信念。',
        score: 1,
        source: '篇章一及篇章二',
        articleIndex: [0, 1]
    },
    {
        id: 'SB1-06',
        category: '一般閱讀題',
        type: '短答題',
        question: '司馬遷少年遠遊對日後著史有甚麼幫助？提出兩點。',
        correctAnswer: '實地考察人物活動地點，增加歷史認識；聽取民間故事，擴闊材料來源與視野。',
        explanation: '實地考察人物活動地點，增加歷史認識（2分）；聽取民間故事，擴闊材料來源與視野（2分）。',
        score: 4,
        source: '篇章一・少年遠遊及寫《史記》的理想',
        articleIndex: [0]
    },
    {
        id: 'SB1-07',
        category: '一般閱讀題',
        type: '短答題',
        question: '父親的囑託如何與司馬遷受刑後的選擇相連？',
        correctAnswer: '父親託付整理歷史，司馬遷承諾不遺漏；受刑時著作未成，這份責任成為他忍辱著書的支撐。',
        explanation: '父親託付整理歷史，司馬遷承諾不遺漏（2分）；受刑時著作未成，這份責任成為他忍辱著書的支撐（2分）。',
        score: 4,
        source: '篇章一・父親的囑託及未完成的心願',
        articleIndex: [0]
    },
    {
        id: 'SB1-08',
        category: '一般閱讀題',
        type: '短答題',
        question: '為甚麼「趙王以為老，遂不召」令人感到沉重？',
        correctAnswer: '廉頗仍希望受用並積極展示能力；趙王受使者言語影響不召回，願望與結果的落差帶出失意。',
        explanation: '廉頗仍希望受用並積極展示能力（2分）；趙王受使者言語影響不召回，願望與結果的落差帶出失意（2分）。',
        score: 4,
        source: '篇章二・廉頗',
        articleIndex: [1]
    },
    {
        id: 'SB1-09',
        category: '一般閱讀題',
        type: '短答題',
        question: '篇章二如何解釋《史記》不只是一部記錄事件的史書？',
        correctAnswer: '作品寫人在困境中的選擇和心情；例如廉頗披甲上馬卻未獲召回，使讀者感到其報國無門的失意。其他有據例子可接受。',
        explanation: '作品寫人在困境中的選擇和心情（2分）；例如廉頗披甲上馬卻未獲召回，使讀者感到其報國無門的失意（2分）。其他有據例子可接受。',
        score: 4,
        source: '篇章二・開首及相似之處',
        articleIndex: [1]
    },
    {
        id: 'SB1-10',
        category: '一般閱讀題',
        type: '短答題',
        question: '《史記》以人物為中心，卻不只寫帝王。這怎樣影響讀者認識歷史？',
        correctAnswer: '把將軍、刺客、商人等不同身分的人納入歷史；讓讀者從多種人生處境理解歷史，避免把歷史只視為帝王事跡。',
        explanation: '把將軍、刺客、商人等不同身分的人納入歷史（2分）；讓讀者從多種人生處境理解歷史，避免把歷史只視為帝王事跡（2分）。',
        score: 4,
        source: '篇章一・寫《史記》的理想',
        articleIndex: [0]
    },

    {
        id: 'SB1-11',
        category: '能力點題',
        type: '選擇題',
        question: '哪一件事直接引發文中司馬遷被判刑下獄？',
        options: [
            {
                option: 'A. 遠遊時聽取民間故事'
            },
            {
                option: 'B. 在朝廷上替兵敗投降的李陵解釋'
            },
            {
                option: 'C. 答應父親整理舊聞'
            },
            {
                option: 'D. 把商人事跡寫入《史記》'
            }
        ],
        correctAnswer: 'B. 在朝廷上替兵敗投降的李陵解釋',
        explanation: '篇章一第三節明載他替李陵解釋而觸怒漢武帝。',
        score: 1,
        source: '篇章一・李陵事件',
        articleIndex: [0],
        ability_point: '1.1 獲取並提取文本內信息'
    },
    {
        id: 'SB1-12',
        category: '能力點題',
        type: '選擇題',
        question: '文中是誰收買前往察看廉頗的使者？',
        options: [
            {
                option: 'A. 秦王'
            },
            {
                option: 'B. 司馬談'
            },
            {
                option: 'C. 郭開'
            },
            {
                option: 'D. 藺相如'
            }
        ],
        correctAnswer: 'C. 郭開',
        explanation: '篇章二第二節明載「廉頗的仇人郭開收買使者」。',
        score: 1,
        source: '篇章二・廉頗',
        articleIndex: [1],
        ability_point: '1.1 獲取並提取文本內信息'
    },
    {
        id: 'SB1-13',
        category: '能力點題',
        type: '短答題',
        question: '按篇章一列出《史記》的篇數，以及記述時代的起點和終點。',
        correctAnswer: '一百三十篇；傳說中的黃帝；漢武帝時代。',
        explanation: '一百三十篇（1分）；傳說中的黃帝（1分）；漢武帝時代（1分）。',
        score: 3,
        source: '篇章一・寫《史記》的理想',
        articleIndex: [0],
        ability_point: '1.1 獲取並提取文本內信息'
    },
    {
        id: 'SB1-14',
        category: '能力點題',
        type: '短答題',
        question: '摘錄廉頗向使者展示能力的兩項行動。',
        correctAnswer: '「一飯斗米，肉十斤」；「被甲上馬」。準確語譯亦可。',
        explanation: '「一飯斗米，肉十斤」（2分）；「被甲上馬」（2分）。準確語譯亦可。',
        score: 4,
        source: '篇章二・廉頗',
        articleIndex: [1],
        ability_point: '1.1 獲取並提取文本內信息'
    },

    {
        id: 'SB1-15',
        category: '能力點題',
        type: '選擇題',
        question: '若要查閱司馬遷親自解釋「忍辱著書」原因的原文，應優先選哪一項？',
        options: [
            {
                option: 'A. 〈太史公自序〉的少年遠遊段'
            },
            {
                option: 'B. 〈廉頗藺相如列傳〉的廉頗晚年段'
            },
            {
                option: 'C. 篇章二的畸人分類表'
            },
            {
                option: 'D. 〈報任安書〉'
            }
        ],
        correctAnswer: 'D. 〈報任安書〉',
        explanation: '〈報任安書〉有「隱忍苟活」及「草創未就」等直接自述。',
        score: 1,
        source: '篇章一・古文原文出處',
        articleIndex: [0],
        ability_point: '1.2 跨來源搜索、導航與篩選'
    },
    {
        id: 'SB1-16',
        category: '能力點題',
        type: '選擇題',
        question: '要同時查證父親囑託與廉頗晚年未獲召回，最合適的來源組合是甚麼？',
        options: [
            {
                option: 'A. 〈太史公自序〉與〈廉頗藺相如列傳〉'
            },
            {
                option: 'B. 〈報任安書〉與少年遠遊地圖'
            },
            {
                option: 'C. 兩篇中的詞語語譯，不看原文'
            },
            {
                option: 'D. 只讀篇章二開首的魯迅評語'
            }
        ],
        correctAnswer: 'A. 〈太史公自序〉與〈廉頗藺相如列傳〉',
        explanation: '前者記父子囑託，後者記廉頗故事，需按查證問題選來源。',
        score: 1,
        source: '篇章一及篇章二・來源連結',
        articleIndex: [0, 1],
        ability_point: '1.2 跨來源搜索、導航與篩選'
    },
    {
        id: 'SB1-17',
        category: '能力點題',
        type: '短答題',
        question: '你要搜集「作者與人物都牽掛未竟志願」的證據。列出兩個應查閱的原文來源，並各寫一個搜尋字句。',
        correctAnswer: '〈報任安書〉，查「草創未就」或「惜其不成」；〈廉頗藺相如列傳〉，查「以示尚可用」或「遂不召」。',
        explanation: '〈報任安書〉，查「草創未就」或「惜其不成」（2分）；〈廉頗藺相如列傳〉，查「以示尚可用」或「遂不召」（2分）。',
        score: 4,
        source: '篇章一・原文出處；篇章二・原文出處',
        articleIndex: [0, 1],
        ability_point: '1.2 跨來源搜索、導航與篩選'
    },
    {
        id: 'SB1-18',
        category: '能力點題',
        type: '短答題',
        question: '同學搜到遠遊地圖、父子對話和著書理想三項資料。若要回答「寫史的家庭責任從何而來」，你會優先用哪項？其餘哪項可補充而不能代替？',
        correctAnswer: '優先用父子對話，因為直接呈現囑託和承諾；著書理想可補充他如何發展志向，但不能代替父親託付的直接證據。亦接受合理說明地圖的輔助作用。',
        explanation: '優先用父子對話，因為直接呈現囑託和承諾（2分）；著書理想可補充他如何發展志向，但不能代替父親託付的直接證據（2分）。亦接受合理說明地圖的輔助作用。',
        score: 4,
        source: '篇章一・少年遠遊、父親的囑託、寫《史記》的理想',
        articleIndex: [0],
        ability_point: '1.2 跨來源搜索、導航與篩選'
    },

    {
        id: 'SB1-19',
        category: '能力點題',
        type: '選擇題',
        question: '「恨私心有所不盡」中的「恨」，依語譯最接近甚麼？',
        options: [
            {
                option: 'A. 憎恨所有讀者不理解自己'
            },
            {
                option: 'B. 遺憾心中志願尚未完成'
            },
            {
                option: 'C. 後悔讀過父親留下的書'
            },
            {
                option: 'D. 怨恨自己沒有遠遊'
            }
        ],
        correctAnswer: 'B. 遺憾心中志願尚未完成',
        explanation: '此處「恨」是遺憾，所指為尚未完成的志願。',
        score: 1,
        source: '篇章一・未完成的心願',
        articleIndex: [0],
        ability_point: '2.1 建構文本字面意義'
    },
    {
        id: 'SB1-20',
        category: '能力點題',
        type: '選擇題',
        question: '依文中語譯，「處死者難」應如何理解？',
        options: [
            {
                option: 'A. 對犯人執行死刑十分困難'
            },
            {
                option: 'B. 找到適合死亡的地點很難'
            },
            {
                option: 'C. 身處可能死亡的危局而應對，才是更難的事'
            },
            {
                option: 'D. 只要處死敵人便能解決危機'
            }
        ],
        correctAnswer: 'C. 身處可能死亡的危局而應對，才是更難的事',
        explanation: '「處死」在本段指置身死地、應對危局，不能套用現代「處決」意思。',
        score: 1,
        source: '篇章二・藺相如',
        articleIndex: [1],
        ability_point: '2.1 建構文本字面意義'
    },
    {
        id: 'SB1-21',
        category: '能力點題',
        type: '短答題',
        question: '用自己的話解釋「通古今之變，成一家之言」。',
        correctAnswer: '貫通古今歷史的變化；在考察基礎上形成自己的見解。',
        explanation: '貫通古今歷史的變化（2分）；在考察基礎上形成自己的見解（2分）。',
        score: 4,
        source: '篇章一・寫《史記》的理想',
        articleIndex: [0],
        ability_point: '2.1 建構文本字面意義'
    },
    {
        id: 'SB1-22',
        category: '能力點題',
        type: '短答題',
        question: '「死或重於泰山，或輕於鴻毛」是否比較身體重量？請解釋兩個比喻。',
        correctAnswer: '不是比較重量；泰山比喻意義重大、價值深重；鴻毛比喻意義輕微；分別在於人為甚麼而死或而活。',
        explanation: '不是比較重量（1分）；泰山比喻意義重大、價值深重（1分）；鴻毛比喻意義輕微（1分）；分別在於人為甚麼而死或而活（1分）。',
        score: 4,
        source: '篇章二・司馬遷與他筆下人物的相似之處',
        articleIndex: [1],
        ability_point: '2.1 建構文本字面意義'
    },

    {
        id: 'SB1-23',
        category: '能力點題',
        type: '選擇題',
        question: '司馬遷「俯首流涕」並承諾「弗敢闕」，最合理的推斷是甚麼？',
        options: [
            {
                option: 'A. 他確定自己永不會遇上困難'
            },
            {
                option: 'B. 他認為父親的舊聞毫無價值'
            },
            {
                option: 'C. 他只是畏懼離家遠遊'
            },
            {
                option: 'D. 他深受父親囑託觸動，鄭重承擔責任'
            }
        ],
        correctAnswer: 'D. 他深受父親囑託觸動，鄭重承擔責任',
        explanation: '動作及承諾相連，支持情感深切及責任感，不能推斷未來必然順遂。',
        score: 1,
        source: '篇章一・父親的囑託',
        articleIndex: [0],
        ability_point: '2.2 生成推斷'
    },
    {
        id: 'SB1-24',
        category: '能力點題',
        type: '選擇題',
        question: '廉頗在使者面前大量進食並披甲上馬，最能推斷他怎樣的心情？',
        options: [
            {
                option: 'A. 急切希望證明仍有能力為國效力'
            },
            {
                option: 'B. 對趙國已徹底失望而拒絕回去'
            },
            {
                option: 'C. 只想向使者炫耀財富'
            },
            {
                option: 'D. 已接受退休並不願再上戰場'
            }
        ],
        correctAnswer: 'A. 急切希望證明仍有能力為國效力',
        explanation: '行動目的由「以示尚可用」點明，可推知其盼望受用的急切。',
        score: 1,
        source: '篇章二・廉頗',
        articleIndex: [1],
        ability_point: '2.2 生成推斷'
    },
    {
        id: 'SB1-25',
        category: '能力點題',
        type: '短答題',
        question: '司馬遷受宮刑後選擇忍辱著書。你認為這算不算有氣節？說明你對氣節的理解，並引一句篇章文字支持。',
        correctAnswer: '立場及氣節定義清楚；引文準確，如「惜其不成」；把未竟責任與忍辱選擇連結論證。可持不同立場，但須據文而論，不能只以受刑判定人格。',
        explanation: '立場及氣節定義清楚（2分）；引文準確，如「惜其不成」（1分）；把未竟責任與忍辱選擇連結論證（3分）。可持不同立場，但須據文而論，不能只以受刑判定人格。',
        score: 6,
        source: '工作紙1・探究1；篇章一',
        articleIndex: [0],
        ability_point: '2.2 生成推斷',
        isSuggested: true
    },
    {
        id: 'SB1-26',
        category: '能力點題',
        type: '短答題',
        question: '篇章二指出司馬遷曾受屈辱。這怎樣有助你推想他為甚麼注意廉頗的失意？並指出推想的界限。',
        correctAnswer: '自身受辱可使他更能體會有志難伸者的痛苦；這是結合處境的合理解讀，不能據此斷定寫廉頗完全等於寫自己。',
        explanation: '自身受辱可使他更能體會有志難伸者的痛苦（2分）；這是結合處境的合理解讀，不能據此斷定寫廉頗完全等於寫自己（2分）。',
        score: 4,
        source: '篇章二・開首及廉頗',
        articleIndex: [1],
        ability_point: '2.2 生成推斷'
    },
    {
        id: 'SB1-27',
        category: '能力點題',
        type: '選擇題',
        question: '哪個次序最能呈現篇章一所寫的司馬遷經歷？',
        options: [
            {
                option: 'A. 李陵事件受刑→少年遠遊→承接父託→完成著述'
            },
            {
                option: 'B. 少年遠遊→承接父託→李陵事件受刑→忍辱完成著述'
            },
            {
                option: 'C. 完成著述→承接父託→少年遠遊→受刑'
            },
            {
                option: 'D. 承接父託→完成著述→少年遠遊→受刑'
            }
        ],
        correctAnswer: 'B. 少年遠遊→承接父託→李陵事件受刑→忍辱完成著述',
        explanation: '篇章按遠遊、父託、受刑及未竟著書志向推進。',
        score: 1,
        source: '篇章一・全篇',
        articleIndex: [0],
        ability_point: '2.3 整合文本內信息'
    },
    {
        id: 'SB1-28',
        category: '能力點題',
        type: '選擇題',
        question: '哪條因果鏈最符合廉頗晚年未被召回的敘述？',
        options: [
            {
                option: 'A. 廉頗拒見使者→趙王生氣→不召'
            },
            {
                option: 'B. 趙王不召→廉頗首次被使者發現→使者被收買'
            },
            {
                option: 'C. 想效國而展示能力→使者受收買失實報告→趙王以為老而不召'
            },
            {
                option: 'D. 廉頗吃得太少→使者忠實報告→趙王立即召回'
            }
        ],
        correctAnswer: 'C. 想效國而展示能力→使者受收買失實報告→趙王以為老而不召',
        explanation: '需連結願望、讒害、判斷和結果，不能把使者的報告當作客觀結論。',
        score: 1,
        source: '篇章二・廉頗',
        articleIndex: [1],
        ability_point: '2.3 整合文本內信息'
    },
    {
        id: 'SB1-29',
        category: '能力點題',
        type: '短答題',
        question: '選藺相如或廉頗的一個片段，整理他的願望、所遇困難及結果，說明哪個言行或遭遇最打動你。',
        correctAnswer: '願望與困難準確；引用合適細節並交代結果；解釋感受與細節的關係。例：廉頗披甲上馬望受用，卻因讒害未被召回，落差令人惋惜。',
        explanation: '願望與困難準確（2分）；引用合適細節並交代結果（2分）；解釋感受與細節的關係（2分）。例：廉頗披甲上馬望受用，卻因讒害未被召回，落差令人惋惜。',
        score: 6,
        source: '工作紙1・探究2；篇章二',
        articleIndex: [1],
        ability_point: '2.3 整合文本內信息',
        isSuggested: true
    },
    {
        id: 'SB1-30',
        category: '能力點題',
        type: '短答題',
        question: '把篇章一的材料整理為「準備—責任—目標」三項，說明司馬遷的著史志向如何形成。',
        correctAnswer: '準備：遠遊、考察及搜集故事；責任：承接父託與舊聞；目標：探究天人、古今變化並形成見解。',
        explanation: '準備：遠遊、考察及搜集故事（2分）；責任：承接父託與舊聞（2分）；目標：探究天人、古今變化並形成見解（2分）。',
        score: 6,
        source: '篇章一・少年遠遊至寫《史記》的理想',
        articleIndex: [0],
        ability_point: '2.3 整合文本內信息'
    },

    {
        id: 'SB1-31',
        category: '能力點題',
        type: '選擇題',
        question: '魯迅認為，要把作者的身世與筆下人物聯繫閱讀。那閱讀司馬遷的《史記》，是應該：',
        options: [
            {
                option: 'A. 結合起來閱讀，看到兩人都在困境中牽掛尚未實現的志願。合讀有助我們理解司馬遷的堅持，也體會廉頗失意的分量。'
            },
            {
                option: 'B. 分別理解司馬遷的生平事跡和他筆下的廉頗的故事，因為兩人身分與處境不同。'
            },
            {
                option: 'C. 只理解廉頗的故事。因司馬遷寫廉頗晚年，只為補充趙國史事，這段文字與人的情感無關。'
            }
        ],
        correctAnswer: 'A. 結合起來閱讀，看到兩人都在困境中牽掛尚未實現的志願。合讀有助我們理解司馬遷的堅持，也體會廉頗失意的分量。',
        explanation: '正確為原題乙：在保留身分與處境差異下，聯繫兩人的未竟志願。',
        score: 1,
        source: '工作紙1・探究3',
        articleIndex: [0, 1],
        ability_point: '2.4 整合跨文本信息',
        isSuggested: true
    },
    {
        id: 'SB1-32',
        category: '能力點題',
        type: '選擇題',
        question: '哪項最準確比較司馬遷與藺相如面對危難的選擇？',
        options: [
            {
                option: 'A. 前者忍辱完成著述，後者臨危應變維護國家，均守護所重視之事'
            },
            {
                option: 'B. 兩人都靠自殺完成著述'
            },
            {
                option: 'C. 兩人都放棄責任以求安全'
            },
            {
                option: 'D. 兩人處境完全相同，因此行動沒有差別'
            }
        ],
        correctAnswer: 'A. 前者忍辱完成著述，後者臨危應變維護國家，均守護所重視之事',
        explanation: '共同點是堅守責任；具體處境和行動並不相同。',
        score: 1,
        source: '篇章一及篇章二',
        articleIndex: [0, 1],
        ability_point: '2.4 整合跨文本信息'
    },
    {
        id: 'SB1-33',
        category: '能力點題',
        type: '短答題',
        question: '從篇章一及篇章二各找一處字句，說明司馬遷與廉頗各自「想完成」甚麼，並指出共同點。',
        correctAnswer: '司馬遷：「草創未就／惜其不成」，希望完成《史記》；廉頗：「以示尚可用」，希望再為趙國效力；共同點：困境中仍牽掛未竟志願。',
        explanation: '司馬遷：「草創未就／惜其不成」，希望完成《史記》（2分）；廉頗：「以示尚可用」，希望再為趙國效力（2分）；共同點：困境中仍牽掛未竟志願（2分）。',
        score: 6,
        source: '工作紙1・探究3',
        articleIndex: [0, 1],
        ability_point: '2.4 整合跨文本信息',
        isSuggested: true
    },
    {
        id: 'SB1-34',
        category: '能力點題',
        type: '短答題',
        question: '整合司馬遷、藺相如及廉頗的事跡，各指出他面對的困難、作出的選擇及想守住的事情。',
        correctAnswer: '司馬遷受刑受辱，忍辱著書，守著述責任；藺相如面對強秦及殺身之禍，勇敢而冷靜應對，守趙國尊嚴與安全；廉頗年老被棄不受信任，展示能力求再受用，守效國之志。',
        explanation: '司馬遷受刑受辱，忍辱著書，守著述責任（2分）；藺相如面對強秦及殺身之禍，勇敢而冷靜應對，守趙國尊嚴與安全（2分）；廉頗年老被棄不受信任，展示能力求再受用，守效國之志（2分）。',
        score: 6,
        source: '工作紙1・探究4',
        articleIndex: [0, 1],
        ability_point: '2.4 整合跨文本信息',
        isSuggested: true
    },

    {
        id: 'SB1-35',
        category: '能力點題',
        type: '選擇題',
        question: '判斷司馬遷自己如何解釋忍辱活着的原因，哪項證據最直接？',
        options: [
            {
                option: 'A. 後人只用「怕死」兩字評價他'
            },
            {
                option: 'B. 他在〈報任安書〉說心願未盡、著作未成'
            },
            {
                option: 'C. 同學猜測他想升官'
            },
            {
                option: 'D. 單憑宮刑是屈辱便推定其動機'
            }
        ],
        correctAnswer: 'B. 他在〈報任安書〉說心願未盡、著作未成',
        explanation: '自述是了解他如何表述動機的直接材料，但不等於能證明所有內心活動。',
        score: 1,
        source: '篇章一・〈報任安書〉選段',
        articleIndex: [0],
        ability_point: '3.1 評估質量與真實性'
    },
    {
        id: 'SB1-36',
        category: '能力點題',
        type: '選擇題',
        question: '同學說：「分類表有商人，所以《史記》認為所有商人都高尚。」這論證有甚麼問題？',
        options: [
            {
                option: 'A. 誤把商人當作帝王'
            },
            {
                option: 'B. 沒有列出所有人的姓名便完全不能討論'
            },
            {
                option: 'C. 把記錄有經營之才的人擴大成對所有商人的道德肯定'
            },
            {
                option: 'D. 分類表絕不可以用作閱讀證據'
            }
        ],
        correctAnswer: 'C. 把記錄有經營之才的人擴大成對所有商人的道德肯定',
        explanation: '原表說的是受輕視但有經營才能，不能推出所有商人的道德評價。',
        score: 1,
        source: '篇章二・畸人分類表',
        articleIndex: [1],
        ability_point: '3.1 評估質量與真實性'
    },
    {
        id: 'SB1-37',
        category: '能力點題',
        type: '短答題',
        question: '有人進一步說：「這就證明司馬遷寫廉頗時，一定是在寫自己。」你會如何修正這句評價，使它更貼近實際情況？',
        correctAnswer: '可改成：兩人都牽掛未竟志願，因此可互相參照，幫助體會失意；材料沒有司馬遷直接自述寫廉頗就是寫自己，應刪去「證明」「一定」等過強語氣。',
        explanation: '可改成：兩人都牽掛未竟志願，因此可互相參照，幫助體會失意（2分）；材料沒有司馬遷直接自述寫廉頗就是寫自己，應刪去「證明」「一定」等過強語氣（2分）。',
        score: 4,
        source: '工作紙1・探究3【評價解讀】',
        articleIndex: [0, 1],
        ability_point: '3.1 評估質量與真實性',
        isSuggested: true
    },
    {
        id: 'SB1-38',
        category: '能力點題',
        type: '短答題',
        question: '趙王憑使者報告判斷廉頗已老，為甚麼這份報告的可信度有問題？若要作出較可靠決定，應補甚麼查證？',
        correctAnswer: '郭開收買使者，存在利益衝突及歪曲動機；可另派獨立人員實際考察並交叉核對能力，不能只依一份報告。',
        explanation: '郭開收買使者，存在利益衝突及歪曲動機（2分）；可另派獨立人員實際考察並交叉核對能力，不能只依一份報告（2分）。',
        score: 4,
        source: '篇章二・廉頗',
        articleIndex: [1],
        ability_point: '3.1 評估質量與真實性'
    },

    {
        id: 'SB1-39',
        category: '能力點題',
        type: '選擇題',
        question: '先詳寫廉頗進食上馬，再用「遂不召」短句收束，有何效果？',
        options: [
            {
                option: 'A. 證明他只重視飲食'
            },
            {
                option: 'B. 減少讀者對結果的注意'
            },
            {
                option: 'C. 表示前面的動作全是多餘'
            },
            {
                option: 'D. 使積極求用與未被召回形成落差，突出失意'
            }
        ],
        correctAnswer: 'D. 使積極求用與未被召回形成落差，突出失意',
        explanation: '詳略對照及願望落空，使簡短結果具有情感重量。',
        score: 1,
        source: '篇章二・廉頗',
        articleIndex: [1],
        ability_point: '3.2 反思內容與形式'
    },
    {
        id: 'SB1-40',
        category: '能力點題',
        type: '選擇題',
        question: '作者引用「知死必勇，非死者難也，處死者難」，主要有何作用？',
        options: [
            {
                option: 'A. 把勇氣由敢死深化為危局中的判斷和承擔'
            },
            {
                option: 'B. 證明所有冒險行為都值得仿效'
            },
            {
                option: 'C. 以數據比較秦趙軍力'
            },
            {
                option: 'D. 說明藺相如毫不畏懼便毋須思考'
            }
        ],
        correctAnswer: 'A. 把勇氣由敢死深化為危局中的判斷和承擔',
        explanation: '引文把敘事提升為對勇氣與困境選擇的反思。',
        score: 1,
        source: '篇章二・開首及藺相如',
        articleIndex: [1],
        ability_point: '3.2 反思內容與形式'
    },
    {
        id: 'SB1-41',
        category: '能力點題',
        type: '短答題',
        question: '選篇章二的一個具體寫法，說明它如何支持「無韻之《離騷》」所指的深厚感情。',
        correctAnswer: '指明寫法與字句，如動作「被甲上馬」對照結果「遂不召」；解釋報國願望落空帶出憂憤／失意，使史事具有情感力量。亦接受有據的其他寫法。',
        explanation: '指明寫法與字句，如動作「被甲上馬」對照結果「遂不召」（2分）；解釋報國願望落空帶出憂憤／失意，使史事具有情感力量（2分）。亦接受有據的其他寫法。',
        score: 4,
        source: '篇章二・開首及廉頗',
        articleIndex: [1],
        ability_point: '3.2 反思內容與形式'
    },
    {
        id: 'SB1-42',
        category: '能力點題',
        type: '短答題',
        question: '若把父子的直接對話刪去，只寫「司馬遷接續父業」，讀者的感受可能有甚麼改變？',
        correctAnswer: '會減弱父親鄭重囑託與兒子承諾的具體聲音；「俯首流涕」「弗敢闕」所呈現的情感和責任重量亦較難直接感受。',
        explanation: '會減弱父親鄭重囑託與兒子承諾的具體聲音（2分）；「俯首流涕」「弗敢闕」所呈現的情感和責任重量亦較難直接感受（2分）。',
        score: 4,
        source: '篇章一・父親的囑託',
        articleIndex: [0],
        ability_point: '3.2 反思內容與形式'
    },

    {
        id: 'SB1-43',
        category: '能力點題',
        type: '選擇題',
        question: '「士可殺，不可辱」與司馬遷忍辱著書表面有衝突，哪個處理最周全？',
        options: [
            {
                option: 'A. 只要受辱便不必閱讀他的理由'
            },
            {
                option: 'B. 先辨明氣節是只關乎不受辱，還是也包括完成責任，再據文判斷'
            },
            {
                option: 'C. 只要作品有名便不能提出疑問'
            },
            {
                option: 'D. 否認司馬遷曾受屈辱'
            }
        ],
        correctAnswer: 'B. 先辨明氣節是只關乎不受辱，還是也包括完成責任，再據文判斷',
        explanation: '衝突涉及氣節的不同界定，應檢視價值標準和行動理由。',
        score: 1,
        source: '篇章一及工作紙1・探究1',
        articleIndex: [0],
        ability_point: '3.3 發現並處理衝突'
    },
    {
        id: 'SB1-44',
        category: '能力點題',
        type: '選擇題',
        question: '甲說廉頗「尚可用」，乙說趙王「以為老」，應如何理解兩說？',
        options: [
            {
                option: 'A. 兩句完全相同，沒有不同立場'
            },
            {
                option: 'B. 趙王說老便可刪去所有展示能力的材料'
            },
            {
                option: 'C. 分辨廉頗的展示、使者報告和趙王判斷，檢視讒害造成的落差'
            },
            {
                option: 'D. 兩句不同，所以整篇必定虛構'
            }
        ],
        correctAnswer: 'C. 分辨廉頗的展示、使者報告和趙王判斷，檢視讒害造成的落差',
        explanation: '一個是展示目的，一個是君主受報告影響的判斷，層次不同。',
        score: 1,
        source: '篇章二・廉頗',
        articleIndex: [1],
        ability_point: '3.3 發現並處理衝突'
    },
    {
        id: 'SB1-45',
        category: '能力點題',
        type: '短答題',
        question: '甲說「敢死才勇敢」，乙說「忍辱活着也能勇敢」。結合兩篇，指出兩說的分歧，並提出可兼容的判準。',
        correctAnswer: '分歧在是否以死亡作為勇氣的唯一標準；藺相如危局應變、司馬遷忍辱著書各有責任；可看是否經判斷承擔困難、守住有意義的責任，不只看生死結果。',
        explanation: '分歧在是否以死亡作為勇氣的唯一標準（1分）；藺相如危局應變、司馬遷忍辱著書各有責任（2分）；可看是否經判斷承擔困難、守住有意義的責任，不只看生死結果（1分）。',
        score: 4,
        source: '篇章二・藺相如；篇章一・未完成的心願',
        articleIndex: [0, 1],
        ability_point: '3.3 發現並處理衝突'
    },
    {
        id: 'SB1-46',
        category: '能力點題',
        type: '短答題',
        question: '同學認為「忍辱活下來必定是怕死」，另一位指出「要完成《史記》」。請用文本處理這兩種解釋，並說明能下的結論有何限度。',
        correctAnswer: '引用「恨私心有所不盡」或「惜其不成」支持未竟著述的動機；文中主要解釋不是畏死，但不能由選段斷言他的所有情緒，更不能以「必定」抹去自述。',
        explanation: '引用「恨私心有所不盡」或「惜其不成」支持未竟著述的動機（2分）；文中主要解釋不是畏死，但不能由選段斷言他的所有情緒，更不能以「必定」抹去自述（2分）。',
        score: 4,
        source: '篇章一・未完成的心願；篇章二・相似之處',
        articleIndex: [0, 1],
        ability_point: '3.3 發現並處理衝突'
    },

    {
        id: 'SB1-47',
        category: '能力點題',
        type: '選擇題',
        question: '同學受批評後想放棄已答應完成的校史訪問。哪個做法最能遷移本組閱讀的啟示？',
        options: [
            {
                option: 'A. 把所有批評都當成敵意而不作修改'
            },
            {
                option: 'B. 為了證明氣節，立即刪掉全部訪問'
            },
            {
                option: 'C. 無論身心狀況如何都獨自硬撐'
            },
            {
                option: 'D. 釐清責任、評估可改善之處並尋求支援，繼續完成有價值的工作'
            }
        ],
        correctAnswer: 'D. 釐清責任、評估可改善之處並尋求支援，繼續完成有價值的工作',
        explanation: '重點是有判斷地承擔未竟責任，也可尋求支援，不是盲目忍受。',
        score: 1,
        source: '篇章一及篇章二；新增校園情境',
        articleIndex: [0, 1],
        ability_point: '4.1 將理解遷移至新情境'
    },
    {
        id: 'SB1-48',
        category: '能力點題',
        type: '選擇題',
        question: '選拔隊員時有人只憑競爭對手的一句負評就淘汰候選人。廉頗故事最提醒評選者甚麼？',
        options: [
            {
                option: 'A. 核對資料來源的利益關係，透過公平實試評估能力'
            },
            {
                option: 'B. 只要曾有功勞便應免試入選'
            },
            {
                option: 'C. 年紀較大者必定能力不足'
            },
            {
                option: 'D. 報告只要簡短便一定可靠'
            }
        ],
        correctAnswer: 'A. 核對資料來源的利益關係，透過公平實試評估能力',
        explanation: '郭開收買使者顯示偏見與利益可能扭曲評估，需要獨立核實。',
        score: 1,
        source: '篇章二・廉頗；新增校園情境',
        articleIndex: [1],
        ability_point: '4.1 將理解遷移至新情境'
    },
    {
        id: 'SB1-49',
        category: '能力點題',
        type: '短答題',
        question: '班上要編校史，但只準備訪問校長。參考《史記》的記人範圍，提出兩項改善及理由。',
        correctAnswer: '加入工友、學生、舊生或其他不同角色的訪問，補足多元經驗；把人物故事與校園變化相連並核對資料，使校史不只記管理者而能呈現整體生活。',
        explanation: '加入工友、學生、舊生或其他不同角色的訪問，補足多元經驗（2分）；把人物故事與校園變化相連並核對資料，使校史不只記管理者而能呈現整體生活（2分）。',
        score: 4,
        source: '篇章一・寫《史記》的理想；新增校園情境',
        articleIndex: [0],
        ability_point: '4.1 將理解遷移至新情境'
    },
    {
        id: 'SB1-50',
        category: '能力點題',
        type: '短答題',
        question: '小組展示時突遇技術故障，組長想以發怒表示「勇敢」。依「處死者難」的讀法，提出兩個更合適的行動並說明理由。',
        correctAnswer: '先冷靜判斷故障，改用口頭或備用材料維持展示；分配成員求助和說明情況，承擔責任而非發怒，體現危局中的判斷與行動。',
        explanation: '先冷靜判斷故障，改用口頭或備用材料維持展示（2分）；分配成員求助和說明情況，承擔責任而非發怒，體現危局中的判斷與行動（2分）。',
        score: 4,
        source: '篇章二・藺相如；新增合作情境',
        articleIndex: [1],
        ability_point: '4.1 將理解遷移至新情境'
    },

    // 能力點題：4.2 創造並傳達新意義
    {
        id: 'SB1-51',
        category: '能力點題',
        type: '選擇題',
        question: '要替本組閱讀寫展板標題，哪個最能傳達三人的共通點而保留差異？',
        options: [
            {
                option: 'A. 同一人生：三人遭遇完全相同'
            },
            {
                option: 'B. 困境中的未竟之志：著書、護國與求用'
            },
            {
                option: 'C. 只論勝敗：成功者才有氣節'
            },
            {
                option: 'D. 忘掉責任：避開困難便能自由'
            }
        ],
        correctAnswer: 'B. 困境中的未竟之志：著書、護國與求用',
        explanation: '標題概括共同的堅持，並以不同目標避免抹平人物差異。',
        score: 1,
        source: '篇章一及篇章二；新增展板設計',
        articleIndex: [0, 1],
        ability_point: '4.2 創造並傳達新意義'
    },
    {
        id: 'SB1-52',
        category: '能力點題',
        type: '選擇題',
        question: '哪個圖卡架構最能向未讀過文章的人清楚傳達「真正的難」？',
        options: [
            {
                option: 'A. 只排列人物名字，全部寫「很勇敢」'
            },
            {
                option: 'B. 只按受辱程度排列高下'
            },
            {
                option: 'C. 各列人物困難、具體選擇及守護目標，再用一句話比較'
            },
            {
                option: 'D. 只放結局，不交代言行與處境'
            }
        ],
        correctAnswer: 'C. 各列人物困難、具體選擇及守護目標，再用一句話比較',
        explanation: '三欄配對可使讀者看見選擇與責任的關係，形成有依據的新表達。',
        score: 1,
        source: '篇章一及篇章二；新增圖卡設計',
        articleIndex: [0, 1],
        ability_point: '4.2 創造並傳達新意義'
    },
    {
        id: 'SB1-53',
        category: '能力點題',
        type: '短答題',
        question: '為「困境中的選擇」小展覽寫一段60至100字導言，須提及司馬遷及另一人物，並用一個共同觀點串連。',
        correctAnswer: '示例：司馬遷忍辱著書，廉頗披甲上馬求再受用。兩人處境不同，卻都牽掛未竟志願。這些選擇讓我們看見，氣節也可在漫長的承擔中呈現。',
        explanation: '示例：司馬遷忍辱著書，廉頗披甲上馬求再受用。兩人處境不同，卻都牽掛未竟志願。這些選擇讓我們看見，氣節也可在漫長的承擔中呈現。評分：兩人事跡準確2分；共通觀點有據2分；連貫清楚及符合字數2分。',
        score: 6,
        source: '篇章一及篇章二',
        articleIndex: [0, 1],
        ability_point: '4.2 創造並傳達新意義'
    },
    {
        id: 'SB1-54',
        category: '能力點題',
        type: '短答題',
        question: '自擬一個能引導同學比較司馬遷與藺相如的討論問題，再提供兩條不同篇章的閱讀提示。',
        correctAnswer: '示例問題：面對危險時，勇敢是否只等於敢死？提示一讀「惜其不成」追問著述責任；提示二讀「處死者難」分析危局判斷。',
        explanation: '示例問題：面對危險時，勇敢是否只等於敢死？提示一讀「惜其不成」追問著述責任；提示二讀「處死者難」分析危局判斷。評分：問題具比較空間2分；兩篇提示準確各1分；提示能推進討論2分。',
        score: 6,
        source: '篇章一及篇章二',
        articleIndex: [0, 1],
        ability_point: '4.2 創造並傳達新意義'
    }
];
